var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat_bubble",
    clipPath: "url(#clip0_1515_1037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6665 1.66669H3.33317C2.4165 1.66669 1.6665 2.41669 1.6665 3.33335V18.3334L4.99984 15H16.6665C17.5832 15 18.3332 14.25 18.3332 13.3334V3.33335C18.3332 2.41669 17.5832 1.66669 16.6665 1.66669ZM16.6665 13.3334H4.99984L3.33317 15V3.33335H16.6665V13.3334Z",
    fill: "#474747"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1515_1037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.e33d8b28d7175e2d8624a97a2a7f51b5.svg";
export { ForwardRef as ReactComponent };